export default "__VITE_ASSET__H4ujniXa__"